module.exports = __webpack_public_path__ + "img/eLearning_content_img_03.4e607b6e.jpg";